module.exports = __webpack_public_path__ + "img/vertical_4_1_6005.adebaa47.png";